import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const legacyIssueRoute: InvariantRoute = {
	name: 'legacy-issue',
	path: '/browse/:issueKey(\\w+-\\d+)(.*)',
	query: ['jql!=(.+)', 'filter!=(.+)'],
};
